const GENDER_OPTIONS = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
];

const LAAO_STATUS_OPTIONS = [
  { label: "Yes", value: true, description: "Implanted" },
  { label: "No", value: false, description: "Non-Implant" },
];

const OAC_STATUS_OPTIONS = [
  { label: "Yes", value: "yes", description: "Documented" },
  { label: "No", value: "no", description: "Contraindicated" },
  { label: "Unknown", value: "unknown", description: "Unrecorded" },
];

const LAAO_CONDITIONS = [
  { label: "CHF", value: "chf" },
  { label: "HTN", value: "htn" },
  { label: "Diabetic", value: "diabetic" },
  { label: "CVA/TIA", value: "cva_tia" },
  { label: "Vasc Disease", value: "vasc_disease" },
];

const VT_CONDITIONS = [
  { label: "ATP", value: "atp" },
  { label: "SHOCK", value: "shock" },
];

const DURATION_OPTIONS = [
  { label: "> 0", value: "0" },
  { label: "> 30 seconds", value: "30s" },
  { label: "> 1 minute", value: "1m" },
  { label: "> 5 minutes", value: "5m" },
  { label: "> 10 minutes", value: "10m" },
];

const AF_BURDEN_PRESETS = [
  { label: "Minimal (<5%)", value: [0, 5] },
  { label: "Periodic (5 - 20%)", value: [5, 20] },
  { label: "Moderate (20 - 50%)", value: [20, 50] },
  { label: "High/Severe (> 50%)", value: [50, 100] },
];

const VT_RATE_PRESETS = [
  { label: "Slow", description: "(100–150)", value: [100, 150] },
  { label: "Moderate", description: "(150–200)", value: [150, 200] },
  { label: "Fast", description: "(200–300)", value: [200, 300] },
  { label: "Full", description: "(0–300)", value: [0, 300] },
];

export const SURGERY_PROCEDURE_CONFIG = [
  {
    id: "laao",
    name: "LAAO",
    reportPrefix: "laao",
    icon: "shield",
    filters: [
      {
        label: "Conditions",
        field: "conditions",
        type: "multiSelect",
        options: LAAO_CONDITIONS,
        queryParam: "conditions",
        description: "Documented patient comorbidities",
        summaryLabel: "Conditions",
      },
      {
        label: "Age",
        field: "age",
        type: "range",
        min: 0,
        max: 110,
        step: 1,
        unit: " years",
        unitSingular: " year",
        queryParam: "age",
        description: "Patient age in years",
        summaryLabel: "Age",
      },
      {
        label: "Gender",
        field: "gender",
        type: "multiSelect",
        options: GENDER_OPTIONS,
        queryParam: "gender",
        description: "Recorded patient gender",
        summaryLabel: "Gender",
      },
    ],
  },
  {
    id: "af",
    name: "AF",
    reportPrefix: "af",
    icon: "heart",
    filters: [
      {
        label: "AF Burden",
        field: "afBurden",
        type: "range",
        min: 0,
        max: 100,
        step: 1,
        unit: "%",
        queryParam: "afBurden",
        description: "Aggregate percentage time in episode",
        summaryLabel: "AF Burden",
        presetsTitle: "Clinical Risk Tier",
        presets: AF_BURDEN_PRESETS,
      },
      {
        label: "OAC Status",
        field: "oacStatus",
        type: "multiSelect",
        options: OAC_STATUS_OPTIONS,
        queryParam: "oacStatus",
        meta: "Oral Anticoagulant",
        description: "Active medication documentation status",
        summaryLabel: "OAC",
      },
      {
        label: "LAAO",
        field: "laaoStatus",
        type: "multiSelect",
        options: LAAO_STATUS_OPTIONS,
        queryParam: "laao",
        description: "Left atrial occlusion therapy",
        summaryLabel: "LAAO",
      },
    ],
  },
  {
    id: "vt",
    name: "VT",
    reportPrefix: "vt",
    icon: "bolt",
    filters: [
      {
        label: "Conditions",
        field: "conditions",
        type: "multiSelect",
        options: VT_CONDITIONS,
        queryParam: "conditions",
        meta: "Therapies",
        description: "Device therapies delivered",
        summaryLabel: "Conditions",
        allSelectedMeansAny: false,
      },
      {
        label: "VT Rate",
        field: "vt_rate",
        type: "range",
        min: 0,
        max: 300,
        step: 5,
        unit: " bpm",
        queryParam: "vt_rate",
        description: "Ventricular rate during VT episodes",
        summaryLabel: "VT Rate",
        presetsTitle: "Rate Category",
        presets: VT_RATE_PRESETS,
      },
      {
        label: "VT Duration",
        field: "vtDuration",
        type: "singleSelect",
        options: DURATION_OPTIONS,
        queryParam: "dur_vt",
        cardTitle: "Episode Duration Windows",
        description: "Direct query mapping to telemetry episode duration",
        inputLabel: "Duration",
        placeholder: "Any Duration",
        summaryLabel: "VT Duration",
      },
      {
        label: "NSVT Duration",
        field: "nsvtDuration",
        type: "singleSelect",
        options: DURATION_OPTIONS,
        queryParam: "dur_nsvt",
        cardTitle: "Episode Duration Windows",
        description: "Direct query mapping to telemetry episode duration",
        inputLabel: "Duration",
        placeholder: "Any Duration",
        summaryLabel: "NSVT Duration",
      },
      {
        label: "VF Duration",
        field: "vfDuration",
        type: "singleSelect",
        options: DURATION_OPTIONS,
        queryParam: "dur_vf",
        cardTitle: "Episode Duration Windows",
        description: "Direct query mapping to telemetry episode duration",
        inputLabel: "Duration",
        placeholder: "Any Duration",
        summaryLabel: "VF Duration",
      },
    ],
  },
];

export const SURGERY_PROCEDURE_MAP = SURGERY_PROCEDURE_CONFIG.reduce(
  (accumulator, procedure) => {
    accumulator[procedure.id] = procedure;

    return accumulator;
  },
  {}
);

export const DEFAULT_SURGERY_PROCEDURE_ID = SURGERY_PROCEDURE_CONFIG[0].id;
